import type ERAR from '$lib/erar/spec';
import { reduceToArrayMap } from '$lib/utils/array';

export function getTeamRankToParticipants(participants: ERAR.Schema.MatchParticipation[]) {
  const teamIdToParticipants = reduceToArrayMap(
    participants,
    (v) => v.team,
    (v) => v,
  );

  const rankToParticipants = new Map<number, ERAR.Schema.MatchParticipation[]>();
  for (const [_, participants] of teamIdToParticipants) {
    const lowestRank = Math.min(...participants.map((v) => v.rank));
    rankToParticipants.set(lowestRank, participants);
  }

  return rankToParticipants;
}
